import type { FC } from "react";
import Actions from "../components/actions/Actions";
import BatchCostInvoice from "./BatchCostInvoice";
import CostsCsvExport from "./CostsCsvExport";
import type { Cost } from "./costTypes";
import CostInvoicePayments from "./payments/CostInvoicePayments";
import { Fab as FloatingActionButton } from "@mui/material";
import { Link } from "react-router-dom";

interface Props {
  readonly values: Cost[];
}

const CostsActions: FC<Props> = ({ values }) => (
  <Actions>
    <IncomingTransfersFAB />
    <CostsCsvExport values={values} />
    <BatchCostInvoice values={values} />
    <CostInvoicePayments values={values} />
  </Actions>
);

function IncomingTransfersFAB() {
  return (
    <Link to="incomming-transfers">
      <FloatingActionButton color="success" title="Przelewy przychodzące">
        🖧
      </FloatingActionButton>
    </Link>
  );
}

export default CostsActions;
